import type { ReferentialEnum } from "../../types"

export const purchasesChannelEnum = {
  FDL: { label: "FDL" },
  DIRECT: { label: "Direct" },
  COALIA: { label: "Coalia" },
  PHARMAT: { label: "My Pharmat" },
  SAGITTA: { label: "Ma Boutique" },
  REPARTITION: { label: "Repartition" },
  RETROCESSION: { label: "Rétrocession" },
  // Other channels
  "VETO SANTE": { label: "Véto Santé" },
  HAD: { label: "HAD" },
  OCP: { label: "OCP" },
  "CERP ROUEN": { label: "CERP Rouen" },
  "CENTRALES D ACHATS": { label: "Centrales d'achats" },
  "ALLIANCE HR": { label: "Alliance HR" },
  SHORTLINER: { label: "Shortliner" },
  GIPHAR: { label: "Giphar" },
  PHOENIX: { label: "Phoenix" },
} as const satisfies ReferentialEnum

export type PurchasesChannelName = keyof typeof purchasesChannelEnum
